import { PagedFilterAndSortedRequest } from '../../dto/pagedFilterAndSortedRequest';

export interface Customer {
  id: string;
  name: string;
  surname: string;
  fullname: string;
  email: string;
  phone: string;
  landline?: string;
  address: string;
  businessName: string;
  secondAddress: string;
  thirdAddress: string;
  postcode: string;
  city: string;
  country: string;
  userId?: number;
  tenantId: number;
  creationTime?: string;
  appRegistrationDate?: string;
  lastJobBookingDate?: string;
  totalJobCount?: number;
  isWalkIn?: boolean;
}
export interface CreateCustomer {
  id?: string;
  name: string;
  surname: string;
  email?: string;
  phone: string;
  landline?: string;
  address?: string;
  businessName?: string;
  secondAddress?: string;
  thirdAddress?: string;
  postcode?: string;
  city?: string;
  country?: string;
  userId?: number;
}
export interface UpdateCustomer {
  id: string;
  name: string;
  surname: string;
  email?: string;
  phone: string;
  landline?: string;
  address?: string;
  businessName?: string;
  secondAddress?: string;
  thirdAddress?: string;
  postcode?: string;
  city?: string;
  country?: string;
}

export const InitialCustomer: CreateCustomer = {
  id: '',
  name: '',
  surname: '',
  email: '',
  phone: '',
  landline: undefined,
  address: undefined,
  businessName: undefined,
  secondAddress: undefined,
  thirdAddress: undefined,
  postcode: undefined,
  city: undefined,
  country: undefined,
};

export interface PagedCustomerDto extends PagedFilterAndSortedRequest {
  keyword?: string | null;
  fullname?: string | null;
  name?: string | null;
  surname?: string | null;
  email?: string | null;
  isAppUser?: boolean | null;
  createdFrom?: string | null;
  createdTo?: string | null;
}

export interface PagedSelectCustomer extends PagedFilterAndSortedRequest {
  keyword?: string | null;
}

export interface CustomerInvite {
  id: string;
  type: 'SmsInvite' | 'EstimateReminder';
  customerId: string | undefined;
  creationDate: Date | string;
}

export type GetCustomerInvite = Pick<CustomerInvite, 'customerId' | 'creationDate' | 'type'>;

export interface CustomerInviteHook {
  customerInvite: CustomerInvite | undefined | null;
  loading: boolean;
}
